import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gfu-project-summary-progress" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-hd gfu-hd--h4 gfu-hd--light _ttu _mb-1 _tc--dark-gray",
  "data-qa": "project-summary:Funded"
}
const _hoisted_3 = { class: "gfu-bt gfu-bt--caption _flex _ai-c _gap-1" }
const _hoisted_4 = { class: "_ttu _tc--accent" }
const _hoisted_5 = { class: "gfu-hd gfu-hd--h4 gfu-hd--light _ttu _mt-3 _mb-1 _tc--dark-gray" }
const _hoisted_6 = { class: "_mb-3" }
const _hoisted_7 = { class: "_flexbtwn" }
const _hoisted_8 = {
  class: "gfu-hd gfu-hd--h4 _whs-nw",
  "data-qa": "project-summary:BackersCount"
}
const _hoisted_9 = {
  key: 0,
  class: "gfu-hd gfu-hd--h4 _whs-nw",
  "data-qa": "project-summary:DaysLeft"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_animated_number = _resolveComponent("animated-number")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_time_left = _resolveComponent("time-left")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.isExpressCrowdfunding)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_2, [
          (_openBlock(), _createBlock(_component_localize, {
            key: $options.percentageOfGoal,
            resource: _ctx.Resources.ProjectHome.ProjectSummaryProgressGoalHeader
          }, {
            default: _withCtx(() => [
              _createVNode(_component_display_currency_value, {
                "format-key": "0",
                "display-tooltip": false,
                tag: "span"
              }, {
                content: _withCtx(({ displayCurrency }) => [
                  _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal / displayCurrency.relativeFactor, 'C0', displayCurrency.symbol)), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal, 'C0')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_animated_number, {
                "format-key": "1",
                number: $options.percentageOfGoal,
                format: "P0"
              }, null, 8 /* PROPS */, ["number"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_icon, {
              "icon-namespace": "ga",
              name: "bolt-solid-icon",
              class: "_tc--accent"
            }),
            _createElementVNode("strong", _hoisted_4, _toDisplayString($options.expressCrowdfundingPhaseLabel), 1 /* TEXT */)
          ]),
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryTotalFundingHeader), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */)),
    _createVNode(_component_display_currency_value, {
      tag: "div",
      class: "gfu-bt gfu-bt--b1 _flex _ai-c",
      "data-qa": "project-summary:Gathered"
    }, {
      "tooltip-content": _withCtx(() => [
        _createTextVNode(_toDisplayString($options.projectSummaryProgressCurrencyConversionTooltipLabel), 1 /* TEXT */)
      ]),
      content: _withCtx(({ displayCurrency }) => [
        _createVNode(_component_animated_number, {
          tag: "h3",
          class: "gfu-hd gfu-hd--d1 _mr-1",
          number: $options.roundToIntegers($props.fundsGathered / displayCurrency.relativeFactor),
          format: "C0",
          "currency-symbol": displayCurrency.symbol
        }, null, 8 /* PROPS */, ["number", "currency-symbol"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_animated_number, {
          tag: "h3",
          class: "gfu-hd gfu-hd--d1 _mr-1",
          number: $options.roundToIntegers($props.fundsGathered),
          format: "C0"
        }, null, 8 /* PROPS */, ["number"])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_progress_bar, {
        value: $props.fundsGathered,
        max: $props.campaignGoal,
        "can-go-over": true,
        "progression-over-class": "gfu-progress-bar__progression-over gfu-progress-bar__progression-over--animated",
        "progression-class": "gfu-progress-bar__progression--accent gfu-progress-bar--animated"
      }, null, 8 /* PROPS */, ["value", "max"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("h4", _hoisted_8, [
        _createVNode(_component_base_icon, {
          name: "user",
          class: "_mr-1"
        }),
        _createVNode(_component_animated_number, {
          number: $props.backersCount,
          format: "N0"
        }, null, 8 /* PROPS */, ["number"]),
        _createTextVNode(" " + _toDisplayString(_ctx.Resources.pluralize($props.backersCount, _ctx.Resources.ProjectHome.AnimatedNumberPluralizedBacker)), 1 /* TEXT */)
      ]),
      (!$props.hideClock)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [
            _createVNode(_component_time_left, { timestamp: $options.myDate }, null, 8 /* PROPS */, ["timestamp"])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}